import { LogoGif } from '@sharedComponents/Logo';
import { DigineticaInput, CartBlock, PhoneBlock } from '@app/Layout/Header/Blocks';
import { Section } from '@ui-kit/Section';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';

import styles from './HeaderMiddle.module.scss';

export const HeaderMiddle = () => {
  return (
    <ErrorBoundaryComponent>
      <Section className={styles.Container}>
        <LogoGif width={240} height={38} />
        <DigineticaInput className={styles.Input} />
        <div className={styles.RightBlock}>
          <PhoneBlock />
          <CartBlock />
        </div>
      </Section>
    </ErrorBoundaryComponent>
  );
};
